import { render } from "./AffiliateInfo.vue?vue&type=template&id=f4f14532"
import script from "./AffiliateInfo.vue?vue&type=script&lang=js"
export * from "./AffiliateInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__